import { render, staticRenderFns } from "./TikTokAdsAddProfileDialog.vue?vue&type=template&id=a5d1e870&scoped=true"
import script from "./TikTokAdsAddProfileDialog.vue?vue&type=script&lang=js"
export * from "./TikTokAdsAddProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./TikTokAdsAddProfileDialog.vue?vue&type=style&index=0&id=a5d1e870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d1e870",
  null
  
)

export default component.exports